// src/components/atoms/Input/Input.tsx
import React from 'react';
import * as styles from './Input.css';
import clsx from 'clsx';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  label?: string;
  /** 왼쪽에 넣을 아이콘 */
  icon?: React.ReactNode;
};

export function Input({
  label,
  id,
  className,
  icon = null,
  ...props
}: InputProps) {
  return (
    <div className={clsx(styles.wrapper, className)}>
      {label && (
        <label htmlFor={id} className={styles.labelStyle}>
          {label}
        </label>
      )}
      <div className={styles.inputWithIcon}>
        {/* 아이콘이 있으면 렌더링 */}
        {icon && <span className={styles.icon}>{icon}</span>}
        <input
          id={id}
          {...props}
          className={clsx(styles.input, className)}
        />
      </div>
    </div>
  );
}